import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import './App.scss';
import './animate.css';
import Button from '@material-ui/core/Button';
import { checkSession, getBackendStats } from '../redux/actions';
import Routes from '../Routes';

let lastFocus = Math.round(new Date().getTime());
let sessionInterval = 0;

const getTimestamp = () => {
  return Math.round(new Date().getTime());
}

function App(props) {
  const { auth } = props;

  useEffect(() => {
    window.addEventListener("focus", () => {
      const dif = getTimestamp() - lastFocus;
      if (dif > 5000) {
        props.checkSession();
      }
    }, false);
    window.addEventListener("blur", () => {
      lastFocus = getTimestamp();
    }, false);
    sessionInterval = setInterval(() => {
      if (document.hasFocus()) {
        props.checkSession();
        props.getBackendStats();
      }
    }, 1000 * 60);
    // eslint-disable-next-line
  }, []);

  const renderSessionMismatch = () => {
    return (
      <div className='container' style={{ textAlign: 'center', padding: 30 }}>
        <h1>Niezgodność sesji - prawdopodobnie aplikacja była otworzona w innym oknie</h1>
        <h2>Proszę się upewnić, że wszystkie inne okna są pozamykane.</h2>
        <Button variant="contained" color="secondary" onClick={() => window.location.reload()}>Restartuj</Button>
      </div>
    );
  }

  return auth.sessionMismatch ? renderSessionMismatch() : <Routes />
}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

export default connect(mapStateToProps, { checkSession, getBackendStats })(App);
